import { Button, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import error404 from '../../assets/notFound/error404.png';
import TwoCone from '../../assets/notFound/twoCone.png';
import { NOT_FOUND } from "../../locales/pages/namespaces";

const NotFound = () => {
	const { t } = useTranslation(NOT_FOUND)
	return (
		<>
			<Grid
				container
				spacing={10}
				direction="column"
				alignItems="center"
				justifyContent="center"
				sx={{ minHeight: '100vh', pt: 1.5, pb: 1, overflow: 'hidden' }}nc
			>
				<Grid xs={12}>
					<Stack direction="row">
						<Grid>
							<Box sx={{ width: { xs: 250, sm: 590 }, height: { xs: 130, sm: 300 } }}>
								<img src={error404} alt="mantis" style={{ width: '100%', height: '100%' }}/>
							</Box>
						</Grid>
						<Grid sx={{ position: 'relative' }}>
							<Box sx={{
								position: 'absolute',
								top: 60,
								left: -40,
								width: { xs: 130, sm: 390 },
								height: { xs: 115, sm: 330 }
							}}>
								<img src={TwoCone} alt="mantis" style={{ width: '100%', height: '100%' }}/>
							</Box>
						</Grid>
					</Stack>
				</Grid>
				<Grid xs={12}>
					<Stack spacing={2} justifyContent="center" alignItems="center">
						<Typography variant="h1">{t('Page Not Found')}</Typography>
						<Typography color="textSecondary" align="center" sx={{ width: { xs: '73%', sm: '61%' } }}>
							{t('The page you are looking was moved, removed, renamed, or might never existed!')}
						</Typography>
						<Button component={Link} to={'/'} color={'info'} variant="contained">
							{t('Back To Home')}
						</Button>
					</Stack>
				</Grid>
			</Grid>
		</>
	)
}

export default NotFound;
